import { render, staticRenderFns } from "./hotelCardV3.vue?vue&type=template&id=fcd6e3c8&scoped=true&"
import script from "./hotelCardV3.vue?vue&type=script&lang=js&"
export * from "./hotelCardV3.vue?vue&type=script&lang=js&"
import style0 from "./hotelCardV3.vue?vue&type=style&index=0&id=fcd6e3c8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcd6e3c8",
  null
  
)

export default component.exports